import { Component, OnInit } from '@angular/core';
import { GeneralFormComponent } from 'src/app/components/controls/general-form/general-form.component';
import { StaticData } from '../../../helpers/static-data';
import { CrudActions } from '../../../models/general.enum';
import { List, Enumerable } from 'linqts';
import { FormGroup } from '@angular/forms';


@Component({
  selector: 'app-guia-uso-external-pqrs',
  templateUrl: './guia-uso-external-pqrs.component.html',
  styleUrls: ['./guia-uso-external-pqrs.component.scss']
})


export class GuiaUsoExternalPqrsComponent extends GeneralFormComponent implements OnInit {

  UserData: any;
  DatosUsuario: any;
  DatosIngreso: any;
  Meses: any = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Dicembre"];
  Registro: any;

  public OnInitEnd() {

    this.Registro = this.utility.GetAllFormControls(this.Pagina.ConfigPage.Controls).find(x => { return x.Name == "Registro" });

    if (StaticData.ExternalPqrContact != null && StaticData.ExternalPqrContact != undefined) {
      this.Registro.Hidden = true;
      this.UserData = StaticData.ExternalPqrContact != undefined ? JSON.parse(StaticData.ExternalPqrContact) : StaticData.ExternalPqrContact;
      this.DatosUsuario = this.UserData.NombreCompleto + ', ID ' + this.UserData.Identificacion;
      let FechaIngreso = new Date();
      this.DatosIngreso = 'Fecha de ingreso a las ' + (FechaIngreso.getHours().toString().length == 1 ? '0' + FechaIngreso.getHours() : FechaIngreso.getHours()) + ":" + (FechaIngreso.getMinutes().toString().length == 1 ? '0' + FechaIngreso.getMinutes() : FechaIngreso.getMinutes()) + ', ' + FechaIngreso.getDate() + ' de ' + this.Meses[(FechaIngreso.getMonth())] + ', ' + FechaIngreso.getFullYear();
    }
  }

  public OnActionEventHandler(event) {
    debugger;
    switch (event.ControlType) {

      case 'Button': {
        switch (event.Name) {
          case 'Inicio': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('GuiaUsoExternalPqrs', 'HomeExternalPQR');
            window.scrollTo(0, 0);
            break
          };
          case 'ConsultaPQRs': {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('GuiaUsoExternalPqrs', 'ConsultaExternalPQR');
            window.scrollTo(0, 0);
            break
          };
          case 'ValidarDocumento':
          {
            var CurrentUrl = window.location.href;
            window.location.href = CurrentUrl.replace('GuiaUsoExternalPqrs', 'ValidarDocumentoExternalPqrs');
            window.scrollTo(0, 0);
            break;
          };
        }
        break
      };      
            
    }
    super.OnActionEventHandler(event);
  }

  SalidaPqrs($event) {
    debugger;
    this.LimpiarSesion();
  }

  public LimpiarSesion() {
    debugger;

    this.DatosUsuario = null;
    this.DatosIngreso = null;
    var CurrentUrl = window.location.href;
    StaticData.ContactAuthenticated = false;
    window.location.href = CurrentUrl.replace('GuiaUsoExternalPqrs', 'ExternalPQRs');

  }

}

